export default `
  mutation createSubscription($subscriptionPriceId: String!, $users: [StripeUserInput]!) {
    createSubscription(subscriptionPriceId: $subscriptionPriceId, users: $users) {
      success
      message
      totalSeats
      clientSecret
      subscriptionId
      isFirstSubscription
      eligibleForTrial
      isDowngrade
    }
  }
`
